import jwtUtil from '../../utils/jwtUtil'

export default {
    state: {
        token: localStorage.getItem('membership-cms-api-token') === 'null' ? null : localStorage.getItem('membership-cms-api-token'),
        drawer: localStorage.getItem('drawer') === 'null' ? false : localStorage.getItem('drawer') === 'true',
        refreshToken: localStorage.getItem('membership-cms-refreshToken'),
        refreshTokenExpiration: localStorage.getItem('membership-cms-refreshTokenExpiration'),
        coachFilters: null,
        sportFilters: null,
        sportClassFilters: null,
        userFilters: null,
        page: 1
    },
    mutations: {
        setToken(state, value) {
            state.token = value
        },
        setDrawer(state, value) {
            state.drawer = value
        },
        setRefreshToken(state, value) {
            state.refreshToken = value
        },
        setRefreshTokenExpiration(state, value) {
            state.refreshTokenExpiration = value
        },
        setCoachFilters(state, value) {
            state.coachFilters = value
        },
        setSportFilters(state, value) {
            state.sportFilters = value
        },
        setSportClassFilters(state, value) {
            state.sportClassFilters = value
        },
        setUserFilters(state, value) {
            state.userFilters = value
        },
        setPage(state, value) {
            state.page = value
        }
    },
    actions: {
        logout({ dispatch }) {
            dispatch('setToken', null)
            dispatch('setDrawer', null)
            dispatch('setRefreshToken', null)
            dispatch('setRefreshTokenExpiration', null)
            dispatch('setCoachFilters', null)
            dispatch('setSportFilters', null)
            dispatch('setSportClassFilters', null)
            dispatch('setUserFilters', null)
        },
        login({ dispatch }, [resp]) {
            if (resp.data.token) {
                dispatch('setToken', resp.data.token)
                dispatch('setDrawer', false)
                dispatch('setRefreshToken', resp.data.refreshToken)
                dispatch('setRefreshTokenExpiration', resp.data.refreshTokenExpiration)
            }
        },
        setPage({ commit }, page) {
            commit('setPage', page)
        },
        setCoachFilters({ commit }, coachFilters) {
            commit('setCoachFilters', coachFilters)
        },
        setSportFilters({ commit }, sportFilters) {
            commit('setSportFilters', sportFilters)
        },
        setSportClassFilters({ commit }, sportClassFilters) {
            commit('setSportClassFilters', sportClassFilters)
        },
        setUserFilters({ commit }, userFilters) {
            commit('setUserFilters', userFilters)
        },
        setToken({ commit }, token) {
            localStorage.setItem('membership-cms-api-token', token)
            commit('setToken', token)
        },
        setDrawer({ commit }, drawer) {
            localStorage.setItem('drawer', drawer)
            commit('setDrawer', drawer)
        },
        setRefreshToken({ commit }, refreshToken) {
            if (refreshToken) {
                localStorage.setItem('membership-cms-refreshToken', refreshToken)
                commit('setRefreshToken', refreshToken)
            } else {
                localStorage.removeItem('refreshToken')
                commit('setRefreshToken', null)
            }
        },
        setRefreshTokenExpiration({ commit }, refreshTokenExpiration) {
            if (refreshTokenExpiration) {
                localStorage.setItem('membership-cms-refreshTokenExpiration', refreshTokenExpiration)
                commit('setRefreshTokenExpiration', refreshTokenExpiration)
            } else {
                localStorage.removeItem('membership-cms-refreshTokenExpiration')
                commit('setRefreshTokenExpiration', null)
            }
        }
    },
    getters: {
        getToken: state => state.token,
        isLoggedIn(state) {
            // is string null because of local storage
            return state.token !== null
        },
        getDrawer: state => state.drawer,
        getRefreshToken: state => state.refreshToken,
        getRefreshTokenExpiration: state => state.refreshTokenExpiration,
        getCoachFilters: state => state.coachFilters,
        getSportFilters: state => state.sportFilters,
        getSportClassFilters: state => state.sportClassFilters,
        getUserFilters: state => state.userFilters,
        getPage: state => state.page,
        // Return the first role found in the JWT (string) or null
        getUserRole: state => jwtUtil.getRole(state.token),
        // Return an array of roles or null
        getUserRoles: state => jwtUtil.getRoles(state.token)
    }
}
